export default __webpack_public_path__ + "static/media/blog.22b7fc74.png";